import { CircularProgress } from "@mui/joy";
import { AddVendedorForm } from "../../../EmpresaComponents/CreateForm/AddVendedorForm";
import { VendedorInfo } from "../../../EmpresaComponents/EditarDealForm";
import { Dispatch, SetStateAction, useState } from "react";
import { SaveButton } from "../../../UtilitiesComponents/SaveButton";
import { CancelButton } from "../../../UtilitiesComponents/CancelButton";
import { useAddVendedoresMutation } from "../../../../api/visitasApi";
import { ErrorMessage } from "../../../UtilitiesComponents/ErrorMessage";
import { getErrorMessage } from "../../../../utils/errorHelpers";

interface Props {
    setVendedoresAgregados: Dispatch<SetStateAction<VendedorInfo[]>>;
    setIsAddVendedores: Dispatch<SetStateAction<boolean>>;
    vendedoresAgregados: VendedorInfo[];
    visitaId: number;
}

export function AddVendedoresToVisita({ visitaId, vendedoresAgregados, setVendedoresAgregados, setIsAddVendedores }: Props) {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [addVendedores, { isLoading, isError }] = useAddVendedoresMutation();

    const onSaveVendedores = async () => {
        try {
            const vendedores = vendedoresAgregados.map((vendedor) => vendedor.vendedorId);
            await addVendedores({ visitaId, vendedores }).unwrap();
            setIsAddVendedores(false);
            setVendedoresAgregados([]);
        } catch (error) {
            setErrorMessage(getErrorMessage(error));
        }
    }

    return (
        <div className="flex flex-col h-full overflow-hidden bg-gray-100 rounded-md p-2 border border-gray-600">

            <AddVendedorForm
                setVendedoresAgregados={setVendedoresAgregados}
                vendedoresAgregados={vendedoresAgregados}
                dealId={visitaId} />
            
            {isError && (
                <ErrorMessage>
                    {errorMessage}
                </ErrorMessage>
            )}

            <div className="flex gap-x-2 justify-center mt-2">
                {isLoading
                ?
                <CircularProgress sx={{
                    "--CircularProgress-progressThickness": "4px",
                    "--CircularProgress-trackThickness": "4px",
                    "--CircularProgress-size": "24px"
                }}/>
                :
                <>
                <SaveButton
                    text="Confirmar vendedores"
                    onClick={onSaveVendedores}
                    type="button"/>

                <CancelButton
                    text="Cancelar"
                    onClick={() => setIsAddVendedores(false)} />
                </>
                }
            </div>

        </div>
    );
}